// Heavy data fetching has moved into pages/property/[id]/index.vue
// so the SSR response is not blocked on the upstream API. This middleware
// now only guards against a missing id param.
export default defineNuxtRouteMiddleware((to) => {
  const { id } = to.params;
  if (!id) {
    return navigateTo("/404");
  }
});
